import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { Global, css } from '@emotion/react';
import './i18n';
import 'focus-visible/dist/focus-visible';
import './index.css';
import ErrorPage from './pages/courtesy-pages/error';
import App from './App';
import SessionContextProvider from './contexts/SessionContext';
import PropertyInfoContext from './contexts/PropertyInfoContext';
import { flateArt } from './flateArt';
import PaymentsContextProvider from './contexts/PaymentsContext';
import { ModalStateProvider } from './contexts/ModalStateContext';
// import { HelmetProvider } from 'react-helmet-async';

const GlobalStyles = css`
  /*
    This will hide the focus indicator if the element receives focus via the mouse,
    but it will still show up on keyboard focus.
  */
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }
`;

export const queryClient = new QueryClient();

function Flate() {
  console.log(flateArt);
  return (
    <ErrorBoundary FallbackComponent={ErrorPage} onReset={() => {}}>
      <SessionContextProvider>
        <PropertyInfoContext>
          <PaymentsContextProvider>
            <ModalStateProvider>
              <QueryClientProvider client={queryClient}>
                <Router>
                  <Global styles={GlobalStyles} />
                  {/* <HelmetProvider> */}
                  <App />
                  {/* </HelmetProvider> */}
                </Router>
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </ModalStateProvider>
          </PaymentsContextProvider>
        </PropertyInfoContext>
      </SessionContextProvider>
    </ErrorBoundary>
  );
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Flate />);
